import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-sheetlabels-popup.svg'


_pushScopeId("data-v-56f88dd4")
const _hoisted_1 = {
  ref: "dropDown",
  id: "drop-down-modal"
}
const _hoisted_2 = { id: "modal-body" }
const _hoisted_3 = { id: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Print Options", -1)
const _hoisted_5 = { id: "btns-wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { id: "spacer" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("p", null, "OR"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  id: "drop-down-logo",
  src: _imports_0
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Printing can be a pain! Forget the hassle, we'll do the heavy lifting! Save time and office supplies while getting professional quality. ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              "aria-label": "Open print preview",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPrintPreview && _ctx.openPrintPreview(...args)))
            }, " PRINT FROM HOME "),
            _hoisted_6,
            _createElementVNode("button", {
              "aria-label": "Let us print",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAndContinue && _ctx.saveAndContinue(...args)))
            }, " LET US PRINT "),
            _hoisted_7
          ]),
          _hoisted_8
        ])
      ])
    ], 512)
  ]))
}